/*  ==========================================================================
    CONTENTCLUSTER ARTICLE
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';
import objectFitImages from "object-fit-images";
import {getAllUrlParams} from '../../utilities/lib/general';

/*
 * MODULE
 */

// callback function
function callbackCcDetailView(container) {

    // magnific popup
    utils.mfp.initSingleImage($(container).find('img'));

    console.log('detail');

}

export function initCcArticle($element) {
    const urlParams = getAllUrlParams(window.location.href);
    const nid = urlParams['nid'];
    let container = $element.find('.cc-service');

    // contentcluster service initialization (if element is in view)
    $element.one('inview', function() {
        if (container.attr('data-type') === 'news') {
            utils.rssLoader.initLoader(container, 'news', 'detail', 'https://www.warmbaderhof.com/rss/bn/ajax?colpos=100&nid='+nid, callbackCcDetailView);
        } else if (container.attr('data-type') === 'events') {
            utils.rssLoader.initLoader(container, 'events', 'detail', 'https://www.warmbaderhof.com/rss-events/bn/ajax?colpos=100&nid='+nid, callbackCcDetailView);
        }
    });
}



// WEBPACK FOOTER //
// ./source/js/modules/lib/cc-article.js